import { render, staticRenderFns } from "./NeedTradingAccountAlert.vue?vue&type=template&id=04c35921"
import script from "./NeedTradingAccountAlert.vue?vue&type=script&lang=js"
export * from "./NeedTradingAccountAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports